// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__g1Nth","links":"Navbar_links__WAaQU"};